(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6278],{

/***/ 92508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BulletedList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var BulletedList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "BulletedList",
  componentId: "sc-1sbizlb-0"
})(["font-size:16px;line-height:1.3;list-style:", ";margin-left:24px;display:flex;flex-direction:column;gap:21px;> li::marker{color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:1.6;gap:12px;}"], function (_ref) {
  var listStyle = _ref.listStyle;
  return listStyle !== null && listStyle !== void 0 ? listStyle : 'disc';
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'decimal' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey;
});

/***/ }),

/***/ 37417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ AnotationText; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32125);

var AnotationText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AnotationText",
  componentId: "sc-1kqso6a-0"
})(["font-size:16px;line-height:190%;@media screen and (max-width:1047px){font-size:15px;line-height:180%;}"]);

/***/ }),

/***/ 98259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useMpocketScript; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


// 修正案1

console.log('4');
var useMpocketScript = function useMpocketScript(src) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoaded = _useState[0],
      setIsLoaded = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState2[0],
      setError = _useState2[1]; // エラー状態をstringまたはnullで初期化


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (false) {} // SSR対策

    var loadScript = /*#__PURE__*/function () {
      var _ref = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _workspace_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  var scriptElement = document.createElement('script');
                  var srcWithTime = src;
                  var time = new Date().getTime();

                  if (srcWithTime.includes('?')) {
                    srcWithTime += "&_t=".concat(time);
                  } else {
                    srcWithTime += "?_t=".concat(time);
                  }

                  scriptElement.src = srcWithTime;
                  scriptElement.async = true;
                  console.log('scriptElement.src:', scriptElement.src);
                  document.body.appendChild(scriptElement); // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);

                  // console.log(`新しいスクリプトを作成しています: ${src}, 非同期設定: ${scriptElement.async}`);
                  var existingScript = document.querySelector("script[src*=\"".concat(src, "\"]"));

                  if (existingScript) {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u65E2\u306B\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u3059: ".concat(src));
                    resolve(existingScript);
                    return;
                  } else {
                    console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304C\u30DA\u30FC\u30B8\u306B\u5B58\u5728\u3057\u307E\u305B\u3093\u3001\u8FFD\u52A0\u3057\u307E\u3059: ".concat(src));
                  } // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;


                  // const scriptElement = document.createElement('script');
                  // scriptElement.src = src;
                  // scriptElement.async = true;
                  scriptElement.onload = function () {
                    console.log('マジカルポケットの外部スクリプトが読み込まれました。');
                    console.log('scriptElement.src:', scriptElement.src);
                    setIsLoaded(true);
                    resolve(scriptElement);
                  };

                  scriptElement.onerror = function () {
                    var errorMessage = 'マジカルポケットの外部スクリプトの読み込みに失敗しました。';
                    console.error(errorMessage);
                    setError(errorMessage); // カスタムエラーメッセージをセット

                    // カスタムエラーメッセージをセット
                    reject(new Error(errorMessage));
                  }; // document.body.appendChild(scriptElement);


                  // document.body.appendChild(scriptElement);
                  console.log("\u30B9\u30AF\u30EA\u30D7\u30C8\u304CDOM\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F: ".concat(src));
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                setError(_context.t0 instanceof Error ? _context.t0.message : String(_context.t0));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function loadScript() {
        return _ref.apply(this, arguments);
      };
    }();

    loadScript();
  }, [src]);
  return {
    isLoaded: isLoaded,
    error: error
  };
};
/*
import { useEffect, useState } from 'react';

export const useMpocketScript = (src: string) => {
  const [isLoaded, setIsLoaded] = useState(false);  // スクリプト(js)読込状況の確認用
  const [error, setError] = useState<string | null>(null);  // エラーメッセージ格納用

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR対策とスクリプト読み込みフラグ確認

    const loadScript = () => {
      //Promiseを利用した非同期処理
      //各種読み込み状態・処理状態に応じた処理を行うため、Promiseを使用
      return new Promise((resolve, reject) => {
        // 既に同じsrcのスクリプトが存在するか確認
        const existingScript = document.querySelector(`script[src="${src}"]`);  

        if (existingScript) { // 存在している場合
          console.log(`スクリプトが既にページに存在します: ${src}`);
          setIsLoaded(true);
          resolve(existingScript);
          return;
        }
        
        // 新しいスクリプト要素の作成
        const scriptElement = document.createElement('script');
        scriptElement.src = src;
        scriptElement.async = true; // 非同期での読込。可読性重視のため、asyncを採用

        // スクリプトの読込成功時
        scriptElement.onload = () => {
          console.log('外部スクリプトが読み込まれました。');
          setIsLoaded(true);
          resolve(scriptElement);
        };

        // スクリプトの読込失敗時
        scriptElement.onerror = () => {
          const errorMessage = '外部スクリプトの読み込みに失敗しました。';
          console.error(errorMessage);
          setError(errorMessage);
          reject(new Error(errorMessage));  //エラーで拒否
        };

        // スクリプトをDOMに追加
        const appendScript = () => {
          if (document.body) {
            document.body.appendChild(scriptElement);
            console.log(`スクリプトがDOMに追加されました: ${src}`);
          } else {
            console.error('document.bodyが存在しません。スクリプトの追加に失敗しました。');
            reject(new Error('document.bodyが存在しません。スクリプトの追加に失敗しました。')); //エラーで拒否
          }
        };

        // ドキュメントの準備状態に応じて作業を変更
        if (document.readyState === 'loading') {   // ドキュメントが読み込み中の場合
          document.addEventListener('DOMContentLoaded', appendScript);
        } else {  // ドキュメントが読み込み済みの場合
          appendScript();
        }
      });
    };

    // スクリプトを同期的に読込
    //　可読性重視、ハンドリングの容易さを重視しての、async選択
    const syncLoadScript = async () => {
      try {
        await loadScript(); // スクリプトの読み込み待ち
      } catch (error) { // エラーが発生時
        setError(error instanceof Error ? error.message : String(error));
      }
    };

    syncLoadScript(); // スクリプトの同期読込
  }, [src]);

  return { isLoaded, error };
};

*/

/***/ }),

/***/ 91598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ReviewPage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/BulletedList.tsx
var BulletedList = __webpack_require__(92508);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Mpocket/AnotationText.tsx
var AnotationText = __webpack_require__(37417);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Financial/Review/index.tsx
















var consolidatedChartList = [{
  title: '売上高',
  id: 'irp-chart-graph-uriage'
}, {
  title: '営業利益',
  id: 'irp-chart-graph-eigyo'
}, {
  title: '経常利益',
  id: 'irp-chart-graph-keijo'
}, {
  title: '親会社株主に帰属する当期純利益',
  id: 'irp-chart-graph-oya'
}, {
  title: '総資産',
  id: 'irp-chart-graph-soshisan'
}, {
  title: '純資産',
  id: 'irp-chart-graph-junshisan'
}, {
  title: '店舗数',
  id: 'irp-chart-graph-tenpo'
}];
var trialChartList = [{
  title: '売上高',
  id: 'irp-chart-graph-uriage_trial'
}, {
  title: '営業利益',
  id: 'irp-chart-graph-eigyo_trial'
}, {
  title: '店舗数',
  id: 'irp-chart-graph-tenpo_trial'
}];
var seiyuChartList = [{
  title: '売上高',
  id: 'irp-chart-graph-uriage_seiyu'
}, {
  title: '営業利益',
  id: 'irp-chart-graph-eigyo_seiyu'
}, {
  title: '店舗数',
  id: 'irp-chart-graph-tenpo_seiyu'
}];
var chartSections = [{
  anchorId: 'hilight01',
  title: '連結',
  annotationId: 'irp-highlight-table-review1',
  afterChartAnnotationId: 'irp-highlight-table-review2',
  chartList: consolidatedChartList
}, {
  anchorId: 'hilight02',
  title: 'トライアル',
  annotationId: 'irp-highlight-table-review_trial',
  chartList: trialChartList
}, {
  anchorId: 'hilight03',
  title: '西友',
  annotationId: 'irp-highlight-table-review_seiyu',
  chartList: seiyuChartList
}];
var ReviewPage = function ReviewPage() {
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/ir-financial-review_r2026.js'); // useMpocketScript('//irpocket.com/5882/irpocket/ir-financial-review.js')

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "stylesheet",
      href: "//irpocket.com/141A/irpocket/irp-style.css"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      titleText: "Financial Highlights",
      subTitleText: "\u6C7A\u7B97\u30EC\u30D3\u30E5\u30FC",
      color: "normal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      id: "irp-hilightTab",
      children: chartSections.map(function (_ref) {
        var anchorId = _ref.anchorId,
            title = _ref.title;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "#".concat(anchorId),
            children: title
          })
        }, anchorId);
      })
    }), chartSections.map(function (_ref2) {
      var anchorId = _ref2.anchorId,
          title = _ref2.title,
          annotationId = _ref2.annotationId,
          afterChartAnnotationId = _ref2.afterChartAnnotationId,
          chartList = _ref2.chartList;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 30,
            pc: 60
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
          id: anchorId,
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 30,
            pc: 60
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnotationText/* AnotationText */.L, {
          id: annotationId
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 30,
            pc: 50
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BulletedList/* BulletedList */.h, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: "\u58F2\u4E0A\u9AD8\u53CA\u3073\u5229\u76CA\u306F\u3001\u56DB\u534A\u671F\u3054\u3068\u306E\u7D2F\u8A08\u3092\u8868\u793A\u3057\u3066\u304A\u308A\u307E\u3059\u3002"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 70,
            pc: 100
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChartWrapper, {
          children: chartList.map(function (_ref3) {
            var title = _ref3.title,
                id = _ref3.id;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(ChartContainer, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  sp: 20,
                  pc: 36
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Chart, {
                id: id
              })]
            }, id);
          })
        }), afterChartAnnotationId && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 80,
              pc: 100
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnotationText/* AnotationText */.L, {
            id: afterChartAnnotationId
          })]
        })]
      }, anchorId);
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 60
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
      children: "\u30B0\u30E9\u30D5\u4E0B\u90E8\u306E\u51E1\u4F8B\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30B0\u30E9\u30D5\u8868\u793A\u306EON/OFF\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u307E\u305F\u3001\u30B0\u30E9\u30D5\u306B\u30AB\u30FC\u30BD\u30EB\u3092\u5408\u308F\u305B\u308B\u3068\u3001\u5BFE\u8C61\u671F\u9593\u3068\u6570\u5024\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
    })]
  });
};

ReviewPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: '業績・財務情報',
    path: '/ir/financial/'
  }, {
    name: '決算レビュー',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u6C7A\u7B97\u30EC\u30D3\u30E5\u30FC",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u56DB\u534A\u671F\u3054\u3068\u306E\u6C7A\u7B97\u6982\u8981\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/financial/review'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Review__ChartWrapper",
  componentId: "sc-1pa8bt-0"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:80px;@media screen and (max-width:1047px){grid-template-columns:repeat(1,1fr);gap:50px;}"]);
var ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Review__ChartContainer",
  componentId: "sc-1pa8bt-1"
})(["display:flex;flex-direction:column;"]);
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Review__Title",
  componentId: "sc-1pa8bt-2"
})(["font-size:24px;font-weight:bold;color:", ";line-height:33.6px;@media screen and (max-width:1047px){font-size:18px;line-height:23.4px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var Chart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Review__Chart",
  componentId: "sc-1pa8bt-3"
})(["height:293px;width:470px;@media screen and (max-width:1047px){height:185.32px;width:100%;}"]);
;// CONCATENATED MODULE: ./src/pages/ir/financial/review.tsx


/***/ }),

/***/ 98226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial/review",
      function () {
        return __webpack_require__(91598);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,4535,9774,2888,179], function() { return __webpack_exec__(98226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);